import { get } from "@/services/axiosUitils";
import {
  PaymentTransaction,
  PaymentTransactionResponse,
} from "@/utils/types/PaymentManagement";

const base = "/nps/admin/payment-entries/";

class PaymentManagementService {
  listPaymentTransactions = async (
    page: number,
    pageSize: number
  ): Promise<PaymentTransactionResponse> => {
    return await get<PaymentTransactionResponse>(base, {
      params: {
        page,
        page_size: pageSize,
      },
    });
  };

  getPaymentTransaction = async (id: string): Promise<PaymentTransaction> => {
    return await get<PaymentTransaction>(`${base}${id}/`);
  };
}

export default new PaymentManagementService();
